import type { RouterOptions } from '@nuxt/schema';

export default <RouterOptions>{ scrollBehaviorType: 'smooth' };
